import Vue from "vue"
import Router from "vue-router"
// import StarterPage from "@/pages/starter/StarterPage.vue"
// import StarterNavbar from "@/layout/StarterNavbar.vue"
// import StarterFooter from "@/layout/StarterFooter.vue"

import MainNavbar from "@/layout/MainNavbar.vue"
import MainFooter from "@/layout/MainFooter.vue"

// import ComingSoon from "@/views/ComingSoon"
import Home from "@/views/Home"
import Services from "@/views/Services"
// import AboutUs from "@/views/AboutUs"
import ContactUs from "@/views/ContactUs"

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: "*",
    //   name: "comingsoon",
    //   components: { default: ComingSoon },
    //   props: { header: { colorOnScroll: 500 } }
    // },
    {
      path: "/",
      name: "home",
      components: { default: Home, header: MainNavbar, footer: MainFooter  },
      props: { header: { colorOnScroll: 500 } }
    },
    {
      path: "/services",
      name: "services",
      components: { default: Services, header: MainNavbar, footer: MainFooter  },
      props: { header: { colorOnScroll: 500 } }
    },
    // {
    //   path: "/aboutus",
    //   name: "aboutus",
    //   components: { default: AboutUs, header: MainNavbar, footer: MainFooter  },
    //   props: { header: { colorOnScroll: 500 } }
    // },
    {
      path: "/contactus",
      name: "contactus",
      components: { default: ContactUs, header: MainNavbar, footer: MainFooter  },
      props: { header: { colorOnScroll: 500 } }
    },
    {
      path: "*",
      name: "home",
      components: { default: Home, header: MainNavbar, footer: MainFooter  },
      props: { header: { colorOnScroll: 500 } }
    },
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
})
